import { createTheme } from '@mui/material/styles'
import { theme as baseTheme } from '@chilecompra/react-kit/styles'

const theme = createTheme({
  ...baseTheme,
  palette: {
    custom: {
      background: '#F2F2F9'
    }
  }
})

export default theme
